"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reloadImage = exports.copyText = void 0;

// Enables a refetch of an image, cache-bused
const reloadImage = imgEl => {
  if (!imgEl || !imgEl.src) return null;
  const url = new URL(imgEl.src);
  const params = url.searchParams;
  params.set("_date", new Date().getTime().toString());
  url.search = params.toString();
  imgEl.src = url.toString();
};

exports.reloadImage = reloadImage;

const copyText = text => {
  const tempInput = document.createElement("input");
  tempInput.value = text;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
};

exports.copyText = copyText;